import { render, staticRenderFns } from "./Drugbook.vue?vue&type=template&id=3c82c030&"
import script from "./Drugbook.vue?vue&type=script&lang=js&"
export * from "./Drugbook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports